import React from 'react'
import PropTypes from "prop-types";
import './style.css';


function EntityExtractionHighlighting ({articleText, highlightedTerms}) {

    const createRegEx = (array) => {
        const reg = `${array.map(highlitedWord => `\\b(${highlitedWord})\\b`).join('|')}`;

        return new RegExp(reg, 'gi');
    }


    function createHighlight (text, highlight) {

        return text.split(createRegEx(highlight)).filter(el => el !== undefined)
    }

    function getHighlightedText(text, highlight) {
        // Split text on highlight term, include term itself into parts, ignore case
        let parts = createHighlight(text, highlight)
        return <span className={'news-content'}>{parts.map(part => (highlight.indexOf(part.toLowerCase()) !== -1) ? <b style={{
            "background-color": "#03ffcb"}}>{part}</b> : part)}</span>;
    }



    return (
        <div className={'scroll-box'}>
            {getHighlightedText(articleText, highlightedTerms)}
        </div>
    )
}

EntityExtractionHighlighting.propTypes = {
    articleText: PropTypes.string,
    highlightedTerms: PropTypes.array
}

export default EntityExtractionHighlighting;


// WEBPACK FOOTER //
// ./src/components/EntityExtractionHighlighting/EntityExtractionHighlighting.jsx